var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairoLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.48911C0 0.666697 0.709252 0 1.58416 0H15.7447C18.0948 0 20 1.79086 20 4C20 6.20914 18.0948 8 15.7447 8H1.58416C0.709251 8 0 7.3333 0 6.51089V1.48911ZM1.16284 24C0.520621 24 0 23.5106 0 22.9069V14.2C0 11.9909 1.90517 10.2 4.25532 10.2C6.60547 10.2 8.51064 11.9909 8.51064 14.2V22.9069C8.51064 23.5106 7.99002 24 7.3478 24H1.16284ZM10.8591 13.2184C10.5267 13.3616 10.5309 13.8069 10.8659 13.9446L15.4934 15.8474C17.2677 16.577 19.2553 15.355 19.2553 13.5345C19.2553 11.695 17.2294 10.4731 15.4505 11.2397L10.8591 13.2184Z",
    fill: "#FAFBFB",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairoLogoDark);
export default __webpack_public_path__ + "static/media/fairo-logo-dark.0ade25dfa0fded825d2c213267761971.svg";
export { ForwardRef as ReactComponent };